export const ROUTES = {
    HOME: '',
    AUTH: {
        LOGIN: 'login',
        REGISTRATION: 'registration',
        RESET_PASSWORD: 'reset-initial-password',
        RESET_PASSWORD_SUCCESS: 'reset-password-success',
        TEMP_LOCKED_ACCOUNT: 'locked',
    },
    DEFAULT: {
        CLIENT_ERROR: 'client-error',
        SERVER_ERROR: 'server-error',
        MAINTENANCE: 'maintenance',
        UNAUTHORIZED: 'unauthorized',
        NOT_FOUND: 'not-found',
        CERTIFICATE: 'certificate',
        NO_PAGE: '*',
    },
    SIDEBAR: {
        ASSESSMENT: 'assessment',
        LEARNING: 'learning',
        LEARNING_TASK: {
            PRINT: 'print',
            EVALUATION_LOG: 'evaluation-log',
            PRINT_EVALUATION_LOG: 'print-evaluation-log',
        },
        PROGRESS: 'progress',
        SURVEY: 'survey',
        ELEMENTS: 'elements',
        PATHWAYS: 'pathways',
        ADMIN: {
            ROOT: 'admin',
            TENANT_CLIENT_ADMINISTRATION: 'tenant-client',
            ASSESSOR: {
                ROOT: 'assessor',
                TASK: 'tasks',
            },
            CREATOR: 'creator',
            CREATOR_PATHWAYS: {
                ROOT: 'pathways',
                CREATE: 'create',
                EDIT: 'edit',
                CERTIFICATE_PREVIEW: 'certificate-preview',
            },
            CREATOR_ELEMENTS: {
                ROOT: 'elements',
                CREATE: 'create',
                EDIT: 'edit',
            },
            CONFIGURATION: {
                ROOT: 'configuration',
                CLIENT_INFO: 'client-info',
                TENANT_INFO: 'tenant-info',
                PW_SESSION: 'pw-session',
                REFERENCES: 'references',
                SHORE_USERS: 'shore-users',
                VESSELS: 'vessels',
                CREW_USERS: 'crew-users',
                CONSENT: 'consent',
            },
            SUBSCRIPTIONS: 'subscriptions',
            MATRICES: 'matrices',
            ROLES: 'roles',
            ANALYTICS: 'analytics',
            TEMPLATES: 'templates',
            VESSEL_DASHBOARD: 'vessel-dashboard',
            FLEET_DASHBOARD: 'fleet-dashboard',
            FLEET_VESSEL: 'fleet-vessel',
            VESSEL_CREW_MEMBER: 'vessel-crew-member',
        },
        SETTINGS: 'settings',
        HELP_CENTER: 'help-center',
        ASK: 'ask',
        PERFORM: 'perform',
    },
    PROFILE_BAR: {
        MY_PROFILE: 'my-profile',
        RESULTS: 'results',
        ACCOUNT_SETTINGS: 'settings',
        HELP_CENTER: 'help-center',
        LOG_OUT: 'log-out',
        USER_NOTIFICATIONS: 'notifications',
    },
};
